module.exports = __webpack_public_path__ + "img/20.c603ddc5.jpg";